import { classNames } from "../App";

// The look every plain input in the app shares. Exported because the password
// field has to wrap its input in a positioned container to hang the show/hide
// toggle off it, and it still has to look like the text input beside it.
export const textInputClassName = 'rounded-lg text-neutral-400 py-2 px-4 border border-neutral-border focus:outline-none bg-white'

export default function CustomTextInput({ className, value, onChange, placeholder, register, type = "text" }) {
    return <input className={classNames(className, textInputClassName)} type={type} value={value} onChange={onChange} placeholder={placeholder} {...register} />
}